import React from 'react';

import CustomLoading from '../../../util_components/custom_loading';
import DataTable from './data_table';
import LoadFailed from './load_failed';

/*
 * PROD-7828 — renders a use_cursor_list list: loading, a failed read (a 403 as a plain notice, since a
 * module user without a payments role is refused only that tab), the table and "Load more".
 * render_rows(rows) replaces the default DataTable when a list has its own table.
 */
const CursorListBody = ({
  list,
  columns,
  rowKey,
  empty_text,
  title_of,
  rowClassName,
  render_rows
}) => {
  if (list.status === 'loading') return <CustomLoading />;
  if (list.status === 'error') {
    return list.error.kind === 'forbidden' ? (
      <div className="tp-banner tp-banner-info">{list.error.text}</div>
    ) : (
      <LoadFailed text={list.error.text} on_retry={list.reload} />
    );
  }
  return (
    <>
      {render_rows ? (
        render_rows(list.rows)
      ) : (
        <DataTable
          columns={columns}
          rows={list.rows}
          rowKey={rowKey}
          emptyText={empty_text}
          rowClassName={rowClassName}
          cardTitle={(r) => <b>{title_of(r)}</b>}
        />
      )}
      {list.error.text ? <LoadFailed text={list.error.text} on_retry={list.load_more} /> : null}
      {list.next ? (
        <div className="tp-list-more">
          <button
            type="button"
            className="tp-btn-out"
            onClick={list.more_busy ? undefined : list.load_more}
            aria-disabled={list.more_busy ? 'true' : undefined}
          >
            {list.more_busy ? 'Loading…' : 'Load more'}
          </button>
        </div>
      ) : null}
    </>
  );
};

export default CursorListBody;
